import { useState, type FormEvent } from "react";
import { MailCheck, Send } from "lucide-react";
import { api } from "../api";
import { Brand } from "../components/Brand";
import { ThemeToggle } from "../components/ThemeToggle";

export function LoginPage() {
  const [email, setEmail] = useState("jb@lvthn.co");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const queryError = new URLSearchParams(window.location.search).get("error");
  const [error, setError] = useState(queryError === "expired" ? "That sign-in link has expired or has already been used. Request a fresh one below." : queryError ? "Sign-in could not be completed. Request a fresh link below." : "");

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api("/api/auth/request-link", { method: "POST", body: JSON.stringify({ email }) });
      setSent(true);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "The sign-in email could not be sent.");
    } finally { setBusy(false); }
  };

  return <main className="login-page">
    <div className="login-theme"><ThemeToggle /></div>
    <section className="login-card">
      <Brand />
      <div className="login-icon">{sent ? <MailCheck /> : <Send />}</div>
      <p className="admin-eyebrow">Private workspace</p>
      <h1>{sent ? "Check your inbox." : "Your proposal studio."}</h1>
      <p>{sent ? <>A single-use sign-in link is on its way to <strong>{email}</strong>. It will expire in 15 minutes.</> : "No password to remember. We’ll email you a secure, one-time link to open the studio."}</p>
      {sent ? <button className="admin-button" type="button" onClick={() => setSent(false)}>Send another link</button> : <form onSubmit={submit}>
        <label>Email address<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" autoFocus required /></label>
        {error && <p className="form-error">{error}</p>}
        <button className="admin-button admin-button--primary" type="submit" disabled={busy}>{busy ? "Sending link…" : "Email me a sign-in link"}</button>
      </form>}
    </section>
  </main>;
}
